import { ComputedRef } from 'vue'

import { HistorySourceCodeViewModel } from '@/presentation/viewmodels/history/historySourceCodeViewModel'

export class HistorySourceCodePresenter {
  private viewModel: HistorySourceCodeViewModel

  constructor(viewModel: HistorySourceCodeViewModel) {
    this.viewModel = viewModel
  }

  get historySourceCodeList(): ComputedRef<{ [judgeId: number]: string }> {
    return this.viewModel.historySourceCodeList
  }

  get isLoading(): ComputedRef<boolean> {
    return this.viewModel.isLoading
  }

  get error(): ComputedRef<Error | null> {
    return this.viewModel.error
  }

  async fetchHistorySourceCodeList(judgeId: number): Promise<void> {
    await this.viewModel.fetchHistorySourceCodeList(judgeId)
  }
}
